import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ATS_Frontend } from '../../components/TS_AppTools/index.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { TS_EditableContent } from '../../components/TS_EditableContent/TS_EditableContent.js';
import { LL_V_L } from '../../components/Layouts/index.js';
import { TS_PropRenderer } from '../../components/TS_PropRenderer/index.js';
import { EditableDBItemV3 } from '../../utils/EditableItem.js';
import { TS_DropDown } from '../../components/TS_Dropdown/index.js';
import { SimpleListAdapter } from '../../components/adapter/Adapter.js';
import { ModuleFE_EditableTest } from '../../_entity/editable-test/index.js';
export class ATS_EditableItemTesting extends ComponentSync {
    static defaultProps = {};
    static screen = {
        name: 'Editable Item Testing',
        key: 'editable-item-testing',
        modulesToAwait: [ModuleFE_EditableTest],
        renderer: this,
        group: ATS_Frontend
    };
    deriveStateFromProps(nextProps, state) {
        state.editableItem ??= this.getEditableItem();
        return state;
    }
    getInitialItem() {
        return ModuleFE_EditableTest.cache.allMutable()[0] ?? { a: '', b: '', c: '', d: '' };
    }
    getEditableItem() {
        return new EditableDBItemV3(this.getInitialItem(), ModuleFE_EditableTest)
            .setSaveAction(async (dbItem) => {
            this.setState({ editableItem: this.state.editableItem });
            return dbItem;
        })
            .setOnChanged(async (editable) => this.setState({ editableItem: editable })).setAutoSave(true);
    }
    render() {
        return _jsx("div", { children: _jsx(EditableItemTestEditor, { editable: this.state.editableItem }) });
    }
}
// const EditableInput = TS_InputV2.editable({type: 'text', saveEvent: ['accept', 'blur']});
const Dropdown_Zevel = TS_DropDown.prepareEditable({
    adapter: SimpleListAdapter(['ani', 'pah', 'zevel'], item => _jsx(_Fragment, { children: item.item })),
    placeholder: 'select pah zevel'
});
class EditableItemTestEditor extends TS_EditableContent {
    render() {
        return _jsxs(LL_V_L, { children: [_jsxs(TS_PropRenderer.Vertical, { label: 'Prop A', children: [_jsx(Dropdown_Zevel, { editable: this.state.editable, prop: 'a' }), this.state.editable.get('a') === 'zevel' && _jsx("div", { children: this.state.editable.get('a') })] }), _jsx(TS_PropRenderer.Vertical, { label: 'Prop B', children: _jsx(Dropdown_Zevel, { editable: this.state.editable, prop: 'b' }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Prop C', children: _jsx(Dropdown_Zevel, { editable: this.state.editable, prop: 'c' }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Prop D', children: _jsx(Dropdown_Zevel, { editable: this.state.editable, prop: 'd' }) })] });
    }
}
//# sourceMappingURL=ATS_EditableItem.js.map